<template>
  <v-dialog v-model="dialog" width="600px" persistent>
    <v-card>
      <v-card-title class="d-flex justify-space-between py-3 px-6">
        Thêm đầu điểm
        <v-btn icon @click="closePopup">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 py-3">
        <v-form ref="form">
          <BaseInput
            isRequiredTitle
            label="Số lượng đầu điểm cần thêm"
            placeholder="Nhập số lượng đầu điểm cần thêm"
            v-model="quantity"
            :rules="[$rules.required, $rules.number, $rules.greaterEqual(1)]"
          />
          <BaseInput
            isRequiredTitle
            label="Hệ số"
            placeholder="Nhập hệ số cho điểm"
            v-model="factor"
            :rules="[$rules.required, $rules.max(1)]"
          />
          <BaseAutocomplete
            isRequiredTitle
            label="Thang điểm"
            placeholder="Chọn thang điểm tương ứng"
            :items="markTypes"
            item-text="title"
            item-value="value"
            :returnObject="false"
            v-model="type"
          />
          <div v-if="type === 'custom'">
            <BaseInput
              isRequiredTitle
              label="Số điểm tối đa"
              placeholder="Nhập số điểm tối đa"
              v-model="limit"
              :rules="[$rules.required, $rules.number]"
            />
          </div>
        </v-form>
        <v-divider />
        <v-checkbox v-model="isInGroup" hide-details>
          <template v-slot:label>
            <span class="body-2"> Các đầu điểm được tạo nằm trong 1 nhóm </span>
          </template>
        </v-checkbox>
      </v-card-text>
      <v-divider />
      <v-card-actions class="px-6 py-3">
        <BaseButton text="Hủy" outlined @click="closePopup" />
        <v-spacer />
        <BaseButton text="Thêm" @click="onSubmit" :loading="loading" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import BaseAutocomplete from '../../../../components/basic/BaseAutocomplete.vue'
import BaseButton from '../../../../components/basic/BaseButton.vue'
import BaseInput from '../../../../components/basic/BaseInput.vue'

export default {
  components: { BaseButton, BaseInput, BaseAutocomplete },
  data() {
    return {
      dialog: false,
      quantity: 1,
      markTypes: [
        { title: 'Thang điểm 10', value: 'per10' },
        { title: 'Thang điểm 100', value: 'per100' },
        { title: 'Thang điểm "Đạt / Không Đạt"', value: 'perBoolean' },
        { title: 'Khác', value: 'custom' },
      ],
      type: 'per10',
      isInGroup: false,
      loading: false,
      limit: 10,
      factor: 0
    }
  },
  computed: {
    ...mapGetters({
      grade: 'grade/getGrade',
    }),
  },
  methods: {
    ...mapActions({
      createMarks: 'gradeMark/createMany',
    }),
    openPopup() {
      this.dialog = true
    },
    closePopup() {
      this.dialog = false
      this.refresh()
    },
    refresh() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async onSubmit() {
      if (!this.$refs['form'].validate()) return
      this.loading = true
      try {
        await this.createMarks({
          type: this.type,
          limit: this.limit,
          isInGroup: this.isInGroup,
          quantity: this.quantity,
          grade: this.grade.id,
          factor: this.factor,
        })
        this.$emit('onCreate')
        this.closePopup()
        this.$alert.success('Tạo đầu điểm thành công')
      } catch (error) {
        this.$alert.error('Tạo đầu điểm thất bại')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
